/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { NgModule } from '@angular/core';
import { MatPseudoCheckbox } from './pseudo-checkbox/pseudo-checkbox';
var MatPseudoCheckboxModule = (function () {
    function MatPseudoCheckboxModule() {
    }
    MatPseudoCheckboxModule.decorators = [
        { type: NgModule, args: [{
                    exports: [MatPseudoCheckbox],
                    declarations: [MatPseudoCheckbox]
                },] },
    ];
    /**
     * @nocollapse
     */
    MatPseudoCheckboxModule.ctorParameters = function () { return []; };
    return MatPseudoCheckboxModule;
}());
export { MatPseudoCheckboxModule };
function MatPseudoCheckboxModule_tsickle_Closure_declarations() {
    /** @type {?} */
    MatPseudoCheckboxModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    MatPseudoCheckboxModule.ctorParameters;
}
export { MatPseudoCheckbox } from './pseudo-checkbox/pseudo-checkbox';
//# sourceMappingURL=index.js.map